<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "OAuth",
  methods: {
    ...mapActions(["OAuth"]),
  },
  async mounted() {
    let search = location.hash.substring(1);
    let obj = JSON.parse(
      '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      }
    );
    if (obj && obj.access_token) {
      let oauth = await this.OAuth(obj.access_token);
      if (oauth) {
        await this.$axios(`/api/analytics/send/`, {
          method: "POST",
          data: {
            brand_name: "",
            brand_id: "",
            content_date: "",
            content_id: "",
            content_name: "",
            content_type: "",
            nosology_name: "",
            content_parameter: "",
            event_type: "auth_success",
            url: this.$root.analyticData.url,
            event_parameter: "",
            page_block: "",
            page_name: "",
            page_type: "",
            nova_id: this.$root.analyticData.nova_id,
            session_id: this.$root.analyticData.session_id,
            user_id: this.$root.analyticData.user_id,
            browser: this.$root.analyticData.browser,
            device_type: this.$root.analyticData.device,
            dpl_id: this.$route.query.access || "",
            os: this.$root.analyticData.os,
            utm_campaign: this.$route.query.utm_campaign || "",
            utm_content: this.$route.query.utm_content || "",
            utm_medium: this.$route.query.utm_medium || "",
            utm_source: this.$route.query.utm_source || "",
            utm_term: this.$route.query.utm_term || "",
          },
        });
        if (obj.state) {
          let url;
          let params;
          try {
            url = new URL(obj.state);
          } catch {
            url = new URL("https://" + obj.state);
          }
          if (window.location.host !== url.host) {
            params = new URLSearchParams(url.search);
            params.append("refresh", oauth.refresh);
            params.append("access_token", oauth.access_token);
            url.search = params;
          }
          window.open(url, "_self");
        } else {
          this.$router.push({ name: "MainPage" });
        }
      } else {
        this.$router.push({ name: "MainPage" });
      }
    } else {
      this.$router.push({ name: "MainPage" });
    }
  },
};
</script>

<style>
</style>